import { connect } from 'react-redux';
import Saml from './Saml';

const mapStateToProps = (state: any) => ({
  saml: state.authSettings.organization.saml,
  isLoading: state.authSettings.organization.isLoading || state.organization.details.isLoading,
  failed: state.authSettings.organization.failed || state.authSettings.organization.saml.metadata.failed,
  isSamlAvailable: state.organization.details.license?.current?.plan?.administration?.sso_available ?? false,
  isSamlVerified: state.authSettings.organization.saml.verified,
  isSamlEnabled: state.authSettings.organization.saml.enabled,
  metadata: state.authSettings.organization.saml.metadata.value,
});

export default connect(mapStateToProps, null)(Saml);
